export const enum HttpError {
  HTTP_400 = 400,
  HTTP_403 = 403,
  HTTP_404 = 404,
  HTTP_429 = 429,
  HTTP_500 = 500,
  HTTP_503 = 503,
  HTTP_514 = 514,
  HTTP_519 = 519,
  HTTP_50X = "50x"
}

export const HttpErrorList = [
  HttpError.HTTP_400,
  HttpError.HTTP_403,
  HttpError.HTTP_404,
  HttpError.HTTP_429,
  HttpError.HTTP_500,
  HttpError.HTTP_503,
  HttpError.HTTP_514,
  HttpError.HTTP_519,
  HttpError.HTTP_50X
];

export const httpErrorMessage: Record<HttpError, string> = {
  [HttpError.HTTP_400]: "Oops! Bad request.",
  [HttpError.HTTP_403]: "You're not allowed to access this page.",
  [HttpError.HTTP_404]:
    "Sorry, but we couldn't find the page you're looking for!",
  [HttpError.HTTP_429]: "Too Many requests.",
  [HttpError.HTTP_500]: "Internal Server Error",
  [HttpError.HTTP_503]: "Service Unavailable - Please try again later",
  [HttpError.HTTP_514]:
    "Server is not responding within the expected time frame",
  [HttpError.HTTP_519]: "Server refused the connection",
  [HttpError.HTTP_50X]: "Oops! Something went wrong with your last request."
};

export const httpErrorTitle: Record<HttpError, string> = {
  [HttpError.HTTP_400]: "Bad request",
  [HttpError.HTTP_403]: "Forbidden",
  [HttpError.HTTP_404]: "Page not found",
  [HttpError.HTTP_429]: "Too Many requests",
  [HttpError.HTTP_500]: "Internal Server Error",
  [HttpError.HTTP_503]: "Service Unavailable",
  [HttpError.HTTP_514]: "Upstream Timeout",
  [HttpError.HTTP_519]: "Connection Refused",
  [HttpError.HTTP_50X]: "Oops!"
};
